// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"footer_footerContainer__30uj-","footer":"footer_footer__1lZIc","row":"footer_row__1zJQ1"};